export const FACT_TAGS = [

  {
    pin: true,
    can_edit: false,
    name: 'processor',
    show: true,
    required: true,
    values: {
      type: '',
      version: '',
      display_text: '',
      name: ''
    },
    priority: 1,
    exclude: false,
    enumVal: ''
  },
  {
    pin: false,
    can_edit: false,
    name: 'oem',
    show: true,
    required: false,
    values: {
      type: '',
      version: '',
      display_text: '',
      name: ''
    },
    priority: 15,
    exclude: true,
    enumVal: ''
  },
  {
    pin: false,
    can_edit: false,
    name: 'operating_system',
    show: true,
    required: false,
    values: {
      type: '',
      version: '',
      display_text: '',
      name: ''
    },
    priority: 3,
    exclude: false,
    enumVal: ''
  },
  {
    pin: false,
    can_edit: true,
    name: 'memory',
    show: true,
    required: false,
    values: {
      type: '',
      version: '',
      display_text: '',
      optane_messaging: true,
      name: ''
    },
    priority: 4,
    exclude: false,
    enumVal: ''
  },
  {
    pin: false,
    can_edit: true,
    name: 'storage',
    show: true,
    required: false,
    values: {
      type: '',
      version: '',
      display_text: '',
      name: '',
      ssd: '',
      hdd: ''
    },
    priority: 5,
    exclude: false,
    enumVal: ''

  },
  {
    pin: false,
    can_edit: true,
    name: 'display',
    show: true,
    required: false,
    values: {
      type: '',
      version: '',
      display_text: '',
      name: ''
    },
    priority: 17,
    exclude: false,
    enumVal: ''
  },
  {
    pin: false,
    can_edit: true,
    name: 'graphics',
    show: true,
    required: false,
    values: {
      type: '',
      version: '',
      display_text: '',
      name: ''
    },
    priority: 7,
    exclude: false,
    enumVal: ''
  },
  // {
  //   pin: false,
  //   can_edit: true,
  //   name: 'camera',
  //   show: true,
  //   required: false,
  //   values: {
  //     type: '',
  //     version: '',
  //     display_text: '',
  //     name: ''
  //   },
  //   priority: 8,
  //   exclude: false,
  //   enumVal: ''
  // },
  {
    pin: false,
    can_edit: true,
    name: 'wifi',
    show: true,
    required: false,
    values: {
      type: '',
      version: '',
      display_text: '',
      name: ''
    },
    priority: 9,
    exclude: false,
    enumVal: ''
  },
  // {
  //   pin: false,
  //   can_edit: false,
  //   name: 'optane_memory',
  //   show: false,
  //   required: true,
  //   values: {
  //     type: '',
  //     version: '',
  //     display_text: '',
  //     name: ''
  //   },
  //   priority: 10,
  //   exclude: true,
  //   enumVal: ''
  // },
  {
    pin: false,
    can_edit: false,
    name: 'thunderbolt',
    show: true,
    required: false,
    values: {
      type: '',
      version: '',
      display_text: '',
      name: ''
    },
    priority: 11,
    exclude: true,
    enumVal: ''
  },
  {
    pin: false,
    can_edit: true,
    name: 'battery',
    show: true,
    required: false,
    values: {
      type: '',
      version: '',
      display_text: '',
      name: ''
    },
    priority: 12,
    exclude: false,
    enumVal: ''
  },
  {
    pin: false,
    can_edit: false,
    name: 'vr',
    show: true,
    required: false,
    values: {
      type: '',
      version: '',
      display_text: '',
      name: ''
    },
    priority: 14,
    exclude: true,
    enumVal: ''
  },
  {
    pin: false,
    show: true,
    name: 'device_type',
    required: false,
    priority: 13,
    can_edit: true,
    updated_at: '',
    values: {
      display_text: '',
      device: 'Laptop',
      type: '',
      version: '',
      name: ''
    },
    exclude: false,
    enumVal: ''
  }
 
];
